import { FraudSettingStyle } from "./style/FraudSettingStyle";
import back from "../../assets/Images/icons/svgIcon/back-arrow.svg";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../../api/axios";
import { APP_URLS } from "../../api/url";
import { toast } from "react-toastify";
import { APIError } from "../../core/utils";
import { Switch } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";
import { confirmAlert } from "react-confirm-alert";
import info from "../../assets/Images/image/info-icon.png";

const FraudSettingsManagement = () => {
  const navigate = useNavigate();

  const [flags, _flags] = useState([]);
  const [actions, _actions] = useState([]);
  const [loading, _loading] = useState(false);
  const [isSaving, _isSaving] = useState(false);

  useEffect(() => {
    getPages();
  }, []);

  const getPages = () => {
    _loading(true);
    API.get(APP_URLS.FRAUD_SETTINGS)
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _loading(false);
          _flags(resp.data.flags);
          _actions(resp.data.actions);
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          _loading(false);
        }
      })
      .catch(function (error) {
        _loading(false);
        let error_message = APIError(error);
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleInputChange = (index, key, value, state) => {
    state((prevList) => {
      const updated = [...prevList];
      updated[index][key] = value;
      return updated;
    });
  };

  const toggleChange = (checked, index, key) => {
    _flags((prevState) => {
      return prevState.map((item, i) => {
        if (index === i) {
          return {
            ...item,
            [key]: checked,
          };
        }
        return item;
      });
    });
  };

  const handleSave = () => {
    if (isSaving) return;

    for (const flag of flags) {
      if (flag.risk_points === "" || flag.risk_points === undefined || flag.risk_points < 0 || flag.risk_points > 40) {
        toast.error(`Risk points should be between 0 and 40 for ${flag.label}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
    }

    for (const action of actions) {
      if (action.min_score > action.max_score) {
        toast.error(`Min score should be smaller than max score for ${action.label}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }

      if (action.min_score === "" || action.min_score === undefined || action.min_score < 0 || action.min_score > 100) {
        toast.error(`Min score should be between 0 and 100 for ${action.label}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      if (action.max_score === "" || action.max_score === undefined || action.max_score < 0 || action.max_score > 100) {
        toast.error(`Max score should be between 0 and 100 for ${action.label}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
    }

    confirmAlert({
      title: "Confirm to save changes",
      message: "Are you sure you want to make these changes?",
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "overlay-custom-class-name",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            const formData = new FormData();

            // Add flags
            flags.forEach((flag, index) => {
              const key = index + 1; // Assuming 1-based indexing as per curl request
              formData.append(`flags[${key}][risk_points]`, String(flag.risk_points));
              formData.append(`flags[${key}][is_active]`, flag.is_active ? "1" : "0");
              formData.append(`flags[${key}][immediate_ban]`, flag.immediate_ban ? "1" : "0");
            });

            // Add actions
            actions.forEach((action, index) => {
              const key = index + 1;
              formData.append(`actions[${key}][min_score]`, String(action.min_score));
              formData.append(`actions[${key}][max_score]`, String(action.max_score));
            });
            _isSaving(true);
            API.post(APP_URLS.FRAUD_SETTINGS, formData)
              .then((res) => {
                _isSaving(false);
                const resp = res.data;
                if (resp.success) {
                  toast.success(
                    "Fraud management settings updated successfully.",
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    }
                  );
                } else {
                  toast.error(resp.message, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }
              })
              .catch((error) => {
                _isSaving(false);
                toast.error(APIError(error), {
                  position: toast.POSITION.TOP_RIGHT,
                });
              });
          },
        },
        { label: "No" },
      ],
    });

  };

  return (
    <FraudSettingStyle>
      <div className="row mt-4">
        <div className="col-md-4 d-flex align-items-center">
          <img
            src={back}
            className="ms-4 backbtn"
            alt="back button"
            onClick={() => navigate(-1)}
          />
        </div>
        <div className="col-md-4">
          <div className="heading">
            <h1 className="text-uppercase">Fraud Setting Management</h1>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="d-flex align-items-center justify-content-end">
          <button
            className="btn"
            disabled={loading || isSaving}
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
      <div className="row mt-4">
        {loading ? (
          <div className="col-lg-8 offset-lg-2">
            <div className="d-flex justify-content-center loader">
              <ThreeDots
                height="150"
                width="150"
                radius="9"
                color="#637df4"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
          </div>
        ) :
          <>
            <div className="col-lg-8 offset-lg-2">
              <h2 className="tableHeader">Flags Management</h2>
              <div className="table-container py-2">
                <table className="table">
                  <thead className="mb-3">
                    <tr className="header">
                      <th className="pageName">Label</th>
                      <th>Active</th>
                      <th>Immediate Ban</th>
                      <th>Risk Points</th>
                    </tr>
                  </thead>

                  <tbody>
                    {flags &&
                      flags.map((flag, index) => {
                        return (
                          <tr key={flag.page}>
                            <td className="pageName">{flag.label}</td>
                            <td>
                              <Switch
                                name="selectAll"
                                checked={
                                  flag.is_active
                                }
                                onChange={(e) => toggleChange(e.target.checked, index, 'is_active')}
                              />
                            </td>
                            <td>
                              <Switch
                                name="selectAll"
                                checked={
                                  flag.immediate_ban
                                }
                                onChange={(e) => toggleChange(e.target.checked, index, 'immediate_ban')}
                              />
                            </td>
                            <td >
                              <input
                                type="number"
                                className="form-control"
                                value={flag.risk_points}
                                onChange={(e) => handleInputChange(
                                  index,
                                  'risk_points',
                                  e.target.value,
                                  _flags
                                )
                                }
                              /></td>

                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-8 offset-lg-2">
              <h2 className="tableHeader">Action Management</h2>
              <div className="table-container py-2">
                <table className="table">
                  <thead className="mb-3">
                    <tr className="header">
                      <th className="pageName">Label</th>
                      <th>Min Score</th>
                      <th>Max Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {actions &&
                      actions.map((action, index) => {
                        return (
                          <tr key={action.page}>
                            <td className="pageName">
                              {action.label}
                              <span title={action.note}>
                                <img src={info} className="ms-1 backbtn" />
                              </span>
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                value={action.min_score}
                                onChange={(e) => handleInputChange(
                                  index,
                                  'min_score',
                                  e.target.value,
                                  _actions
                                )
                                }
                              /></td>
                            <td >
                              <input
                                type="number"
                                className="form-control"
                                value={action.max_score}
                                onChange={(e) => handleInputChange(
                                  index,
                                  'max_score',
                                  e.target.value,
                                  _actions
                                )
                                }
                              /></td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        }
      </div>
    </FraudSettingStyle>
  );
};
export default FraudSettingsManagement;
